
      import UploadSimple from './upload-simple.vue'
      import type { App, Plugin } from 'vue'

      export const UploadSimplePlugin: Plugin = {
        install(app: App) {
          app.component('UploadSimple', UploadSimple)
        },
      }
      export { UploadSimple }
      